import { render, staticRenderFns } from "./number-field.vue?vue&type=template&id=4b62d92b&scoped=true&"
import script from "./number-field.vue?vue&type=script&lang=ts&"
export * from "./number-field.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b62d92b",
  null
  
)

export default component.exports